var l = Object.defineProperty;
var h = (i, a, t) => a in i ? l(i, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[a] = t;
var o = (i, a, t) => (h(i, typeof a != "symbol" ? a + "" : a, t), t);
class c {
  transformOptions(a) {
    return process.env.LEAD_GENERATOR_APPLICATION_ID && (a.headers.ConsumerApplication = process.env.LEAD_GENERATOR_APPLICATION_ID), process.env.GATSBY_LEAD_GENERATOR_APPLICATION_ID && (a.headers.ConsumerApplication = process.env.GATSBY_LEAD_GENERATOR_APPLICATION_ID), process.env.GATSBY_COMMUNICATION_KEY && (a.headers["communication-key"] = process.env.GATSBY_COMMUNICATION_KEY), Promise.resolve(a);
  }
}
class _ extends c {
  constructor(t, r) {
    super();
    o(this, "http");
    o(this, "baseUrl");
    o(this, "jsonParseReviver");
    this.http = r || window, this.baseUrl = t ?? "";
  }
  /**
   * Get business rules
   * @return Payload of Dictionary of Double
   */
  getBusinessRules() {
    let t = this.baseUrl + "/businessRules";
    t = t.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(r).then((s) => this.http.fetch(t, s)).then((s) => this.processGetBusinessRules(s));
  }
  processGetBusinessRules(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Get health
   * @return Payload of HealthDto
   */
  getHealth() {
    let t = this.baseUrl + "/health";
    t = t.replace(/[?&]$/, "");
    let r = {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    };
    return this.transformOptions(r).then((s) => this.http.fetch(t, s)).then((s) => this.processGetHealth(s));
  }
  processGetHealth(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Capture Fire Lead
   * @param leadRequestBody (optional) 
   * @return Payload of QuoteDto
   */
  captureFireLead(t) {
    let r = this.baseUrl + "/quotes";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processCaptureFireLead(n));
  }
  processCaptureFireLead(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r === 400 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDto", r, e, s, n);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Get tariff
   * @param getTariffParameterObject (optional) 
   * @return Payload of TariffDto
   */
  getTariff(t) {
    let r = this.baseUrl + "/quotes/tariffs";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processGetTariff(n));
  }
  processGetTariff(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Get tariff v2
   * @param getTariffParameterObject (optional) 
   * @return Payload of TariffV2Basic
   */
  getTariffV2(t) {
    let r = this.baseUrl + "/quotes/tariffsv2/basetariffs";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processGetTariffV2(n));
  }
  processGetTariffV2(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Get tariff v2 - options
   * @param getTariffOptionsParameterObject (optional) 
   * @return Payload of Array of TariffV2Option
   */
  getTariffV2Options(t) {
    let r = this.baseUrl + "/quotes/tariffsv2/tariffOptions";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processGetTariffV2Options(n));
  }
  processGetTariffV2Options(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Capture WTC Fire Lead
   * @param wtcRequestBody (optional) 
   * @return Payload of QuoteDto
   */
  captureWTCFireLead(t) {
    let r = this.baseUrl + "/quotes/wtc";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processCaptureWTCFireLead(n));
  }
  processCaptureWTCFireLead(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r === 400 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDto", r, e, s, n);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Capture WTC Fire Lead V2
   * @param fireWtcRequestBodyV2 (optional) 
   * @return Payload of QuoteDto
   */
  captureWTCFireLeadV2(t) {
    let r = this.baseUrl + "/quotes/wtcV2";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processCaptureWTCFireLeadV2(n));
  }
  processCaptureWTCFireLeadV2(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r === 400 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDto", r, e, s, n);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
  /**
   * Capture Fire Lead v2
   * @param fireLeadRequestBodyV2 (optional) 
   * @return Payload of QuoteDto
   */
  captureFireLeadV2(t) {
    let r = this.baseUrl + "/quotesV2";
    r = r.replace(/[?&]$/, "");
    let e = {
      body: JSON.stringify(t),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return this.transformOptions(e).then((n) => this.http.fetch(r, n)).then((n) => this.processCaptureFireLeadV2(n));
  }
  processCaptureFireLeadV2(t) {
    const r = t.status;
    let s = {};
    return t.headers && t.headers.forEach && t.headers.forEach((e, n) => s[n] = e), r === 200 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), n;
    }) : r === 400 ? t.text().then((e) => {
      let n = null;
      return n = e === "" ? null : JSON.parse(e, this.jsonParseReviver), u("Payload of ErrorDto", r, e, s, n);
    }) : r !== 200 && r !== 204 ? t.text().then((e) => u("An unexpected server error occurred.", r, e, s)) : Promise.resolve(null);
  }
}
var f = /* @__PURE__ */ ((i) => (i.QuoteLead = "QuoteLead", i.WtcMin = "WtcMin", i))(f || {}), p = /* @__PURE__ */ ((i) => (i.Open = "Open", i.HalfOpenOrClosed = "HalfOpenOrClosed", i.Apartment = "Apartment", i))(p || {}), d = /* @__PURE__ */ ((i) => (i.Owner = "Owner", i.Tenant = "Tenant", i))(d || {}), v = /* @__PURE__ */ ((i) => (i.QuoteLead = "QuoteLead", i.WtcMin = "WtcMin", i))(v || {}), O = /* @__PURE__ */ ((i) => (i.RiskLevel = "RiskLevel", i.NumberOfRoomsTooLow = "NumberOfRoomsTooLow", i.NumberOfRoomsTooHigh = "NumberOfRoomsTooHigh", i))(O || {}), A = /* @__PURE__ */ ((i) => (i.PropertyDescription = "PropertyDescription", i.PropertyAddress = "PropertyAddress", i.PropertySpaces = "PropertySpaces", i))(A || {}), E = /* @__PURE__ */ ((i) => (i.BusinessRule = "BusinessRule", i.UserExit = "UserExit", i))(E || {});
class P extends Error {
  constructor(t, r, s, e, n) {
    super();
    o(this, "message");
    o(this, "status");
    o(this, "response");
    o(this, "headers");
    o(this, "result");
    o(this, "isApiException", !0);
    this.message = t, this.status = r, this.response = s, this.headers = e, this.result = n;
  }
  static isApiException(t) {
    return t.isApiException === !0;
  }
}
function u(i, a, t, r, s) {
  throw s ?? new P(i, a, t, r, null);
}
export {
  P as ApiException,
  _ as FireApiClient,
  c as FireApiClientBase,
  f as FireLeadRequestBodyV2LeadType,
  p as GetTariffParameterObjectBuildingType,
  d as GetTariffParameterObjectResidentType,
  v as LeadRequestBodyLeadType,
  O as WtcReasonBusinessRule,
  A as WtcReasonPage,
  E as WtcReasonReason
};
